export const SETUP_GROUP_STACK = 'SETUP_GROUP_STACK'
export const TOGGLE_GROUP_STACK = 'TOGGLE_GROUP_STACK'
export const RESIZE_GROUP_STACK = 'RESIZE_GROUP_STACK'
export const CHANGE_MEMBERS_PER_PAGE = 'CHANGE_MEMBERS_PER_PAGE'
export const SETUP_IMPORT_RESULTS_STATE = 'SETUP_IMPORT_RESULTS_STATE'

export const NEW_GROUP = 'NEW_GROUP'
export const CLOSE_GROUP_STACK = 'CLOSE_GROUP_STACK'

export const CREATE_NEW_GROUP = 'CREATE_NEW_GROUP'
export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST'

export const UPDATE_GROUP = 'UPDATE_GROUP'
export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST'

export const DELETE_GROUP_MEMBER = 'DELETE_GROUP_MEMBER'
export const DELETE_GROUP_MEMBER_REQUEST = (groupId) => `DELETE_GROUP_${groupId}_MEMBER_REQUEST`

export const DELETE_ALL_GROUP_MEMBERS = 'DELETE_ALL_GROUP_MEMBERS'
export const DELETE_ALL_GROUP_MEMBERS_REQUEST = 'DELETE_ALL_GROUP_MEMBERS_REQUEST'

export const INITIALIZE_GROUP_STACK = 'INITIALIZE_GROUP_STACK'
export const INITIALIZE_GROUP_STACK_REQUEST = 'INITIALIZE_GROUP_STACK_REQUEST'

export const CHANGE_GROUP_NAME = 'CHANGE_GROUP_NAME'
export const CHANGE_GROUP_NAME_REQUEST = 'CHANGE_GROUP_NAME_REQUEST'

export const LOAD_GROUP_MEMBERS = 'LOAD_GROUP_MEMBERS'
export const LOAD_GROUP_MEMBERS_REQUEST = 'LOAD_GROUP_MEMBERS_REQUEST'

export const INSERT_MEMBER_TO_GROUP = 'INSERT_MEMBER_TO_GROUP'
export const INSERT_MEMBER_TO_GROUP_REQUEST = (groupId) => `INSERT_MEMBER_TO_GROUP_${groupId}_REQUEST`

export const LOCALE_PREFIX = 'scenes.Gnosus.components.GroupStack'

export const ADD_GROUP_TO_ENTITY_STACK = 'ADD_GROUP_TO_ENTITY_STACK'
export const CHANGE_ENTITY_STACK_GROUP_DATA = 'CHANGE_ENTITY_STACK_GROUP_DATA'
export const CHANGE_ENTITY_STACK_GROUP_MEMBERS = 'CHANGE_ENTITY_STACK_GROUP_MEMBERS'

export const GROUP_STACK_NAME_BEING_EDITED = 'GROUP_STACK_NAME_BEING_EDITED'

export const GROUP_STACK_EXPORT_MEMBERS = 'GROUP_STACK_EXPORT_MEMBERS'

export const GROUP_STACK_FILTER_GET_MEMBERS_REQUEST = 'GROUP_STACK_FILTER_GET_MEMBERS_REQUEST'
